//ar.js
const ar = {
  // 公共
  common: {
    notSupport: 'متصفحك لا يدعم وضع ملء الشاشة',
    loadFail: 'فشل تحميل القالب',
    noPermission: 'عذرًا، ليس لديك إذن للوصول إلى هذه الصفحة',
    backHome: 'العودة إلى الصفحة الرئيسية',
    noExit: 'الصفحة التي تحاول الوصول إليها غير موجودة',
    serverError: 'عذرًا، واجه الخادم خطأً',
    slide: 'مرر لليمين',
    veryHigh: 'عالي جدا',
    high: 'عالي',
    target: 'الهدف',
    urgentLow: 'منخفض جدا',
    agpNoData: `\u202A ${'يتطلب إنشاء تقرير'}\u202C\u202A${'  AGP '} \u202C\u202A${'بيانات لا تقل عن'}\u202C\u202A${' 5  '}\u202C\u202A${' أيام'}\u202C`,
    noDataStr: 'لا توجد بيانات',
    setting: 'الإعداد',
    personInfo: 'المعلومات الأساسية',
    updatePwd: 'تغيير كلمة المرور',
    upHead: 'تحميل الصور',
    inRange: 'ضمن النطاق',
    normal: 'عادي',
    low: 'منخفض',
    previous: 'السابق',
    next: 'التالي',
    search: 'بحث',
    reset: 'إعادة تعيين',
    cancel: 'إلغاء',
    ok: 'موافق',
    confirm: 'تأكيد',
    save: 'حفظ',
    submit: 'إرسال',
    successful: 'ناجح',
    pleaseEnter: 'يرجى إدخال',
    pleaseSelect: 'يرجى تحديد',
    success: 'ناجح',
    confirmLogout: 'هل أنت متأكد من رغبتك في تسجيل الخروج؟',
    updateSuccessed: 'تم التحديث بنجاح',
    warning: 'تحذير',
    date: 'التاريخ',
    start: 'البداية',
    end: 'النهاية',
    sevenDays: '٧ أيام',
    fourteenDays: '١٤ يومًا',
    thirtyDays: '٣٠ يومًا',
    signOut: 'تسجيل الخروج',
    personalInformation: 'المعلومات الشخصية',
    email: 'البريد الإلكتروني',
    name: 'الاسم',
    mobile: 'الجوال',
    dateOfBirth: 'تاريخ الميلاد',
    gender: 'الجنس',
    diabeteType: 'نوع السكري',
    dateOfDignose: 'سنة التشخيص',
    remarks: 'الملاحظات',
    optionMale: 'ذكر',
    optionFemale: 'أنثى',
    optionUnknow: 'أُفضّل عدم التصريح',
    noDiabetes: 'لا أعاني من السكري',
    diabeteTypeI: 'النوع الأول',
    diabeteTypeII: 'النوع الثاني',
    diabeteSpecial: 'خاص',
    diabeteGestational: 'سكري الحمل',
    diabeteOthers: 'أخرى',
    ruleMsgEmail: 'الرجاء إدخال البريد الإلكتروني',
    ruleMsgName: 'الرجاء إدخال الاسم',
    ruleMsgMobile: 'الرجاء إدخال الجوال',
    ruleMsgBirthday: 'الرجاء تحديد تاريخ الميلاد',
    ruleMsgSex: 'الرجاء تحديد الجنس',
    ruleMsgDiabeteType: 'الرجاء تحديد نوع السكري',
    ruleMsgDateOfDignose: 'الرجاء تحديد سنة التشخيص',
    ruleMsgRemarks: 'الرجاء إدخال الملاحظات',
    ruleMsgCorrectMobile: 'الرجاء إدخال الجوال الصحيح',
    oldPassword: 'كلمة المرور القديمة',
    newPassword: 'كلمة المرور الجديدة',
    confirmPassword: 'تأكيد كلمة المرور',
    ruleMsgOldPassword: 'الرجاء إدخال كلمة المرور القديمة',
    ruleMsgNewPassword: 'الرجاء إدخال كلمة المرور الجديدة',
    ruleMsgConfirmPassword: 'الرجاء تأكيد كلمة المرور',
    passwordInconsistent: 'إدخالا كلمة المرور غير متطابقين',
    passwordModifySuccessed:
      'تم إعادة تعيين كلمة المرور، يُرجى تسجيل الدخول مرة أخرى!',
    monday: 'الاثنين',
    tuesday: 'الثلاثاء',
    wednesday: 'الأربعاء',
    thursday: 'الخميس',
    friday: 'الجمعة',
    saturday: 'السبت',
    sunday: 'الأحد',
    sn: 'الرقم التسلسلي',
    startDate: 'تاريخ البدء',
    days: 'أيام', // 保留原样
    pdfDate: 'الهدف', // 保留原样
    close: 'إغلاق', // 保留原样
    inputTip: 'يرجى إدخال كلمات رئيسية للبحث',
    polarization: 'جاري تهيئة الجهاز',
    hour: 'س',
    minutes: 'د',
    seconds: 'ث',
    reportDownLoadTip: 'لم يتم إنشاء تقريرك منذ ٥ أيام',
    age: 'العمر',
    goal: 'الهدف',
    expired: 'انتهت صلاحية المستشعر', // 保留原样
    lastTime: 'آخر وقت للتحديث',
    timeZone: 'المنطقة الزمنية'
  },
  // 路由
  route: {
    login: 'تسجيل الدخول',
    forget: 'نسيت كلمة المرور',
    home: 'الصفحة الرئيسية',
    glucoseReport: 'تقرير الجلوكوز',
    sessionReport: 'تقرير الجلسة',
    eventList: 'قائمة الأحداث',
    followerList: 'قائمة المتابعين',
    followerListQ: 'طلب مراقب',
    settings: 'الإعدادات',
    profile: 'الملف الشخصي'
  },
  // 登录
  login: {
    rememberMe: 'تذكرني',
    forgetPassword: 'نسيت كلمة المرور',
    agree: 'تسجيل الدخول يعني الموافقة على ',
    privacyPolicy: 'سياسة الخصوصية',
    CGMUser: 'مستخدم CGM',
    follower: 'متابع',
    ruleMsgPassword: 'يرجى إدخال كلمة المرور',
    login: 'تسجيل الدخول',
    phonePlacehold: 'يرجى إدخال رقم الهاتف',
    codePlacehold: 'يرجى إدخال رمز التحقق',
    codePlaceholdInput: 'يرجى إدخال...',
    phoneTip: 'عن طريق الهاتف',
    emialTip: 'عن طريق البريد الإلكتروني',
    codeTip: 'احصل على رمز التحقق',
    reGetTip: 'إعادة الحصول'
  },
  layout: {
    collapseUp: 'إخفاء القائمة',
    collapseDown: 'توسيع القائمة',
    refresh: 'تحديث',
    backHome: 'الصفحة الرئيسية',
    helpCenter: 'مركز المساعدة',
    fullScreen: 'ملء الشاشة'
  },
  // 忘记密码
  forget: {
    ruleMsgCode: 'يرجى إدخال الرمز',
    sendCode: 'إرسال الرمز',
    tipsMsgSendSuccess: 'تم إرسال رمز التحقق بنجاح!',
    tipsMsgModifySuccess: 'تم تعديل كلمة المرور بنجاح'
  },
  // 首页
  home: {
    title: 'بوابة FurCarer',
    todaysGlucose: 'الجلوكوز اليوم',
    todaysOverview: 'نظرة عامة اليوم',
    maxGlucose: 'أقصى مستوى جلوكوز',
    minGlucose: 'أدنى مستوى جلوكوز',
    avgGlucose: 'متوسط ​​مستوى الجلوكوز',
    maxmumVariation: 'أقصى تباين',
    glucose: 'الجلوكوز',
    tir: 'TIR',
    latestGlucose: 'آخر مستوى جلوكوز',
    todayPercentage: '% من اليوم في نطاق مختلف',
    fourHour: '4 ساعات',
    eightHour: '8 ساعات',
    twelveHour: '12 ساعة',
    twentyFourHour: '24 ساعة',
    glucoseOnly: 'الجلوكوز فقط',
    sessionOverview: 'نظرة عامة على الجلسة',
    glocuseMetrics: 'مقاييس الجلوكوز',
    agp: 'AGP',
    dailyGlucose: 'الجلوكوز اليومي',
    sessionGlucose: 'جلوكوز الجلسة',
    standTir: 'القياسيTIR',
    customTir: 'المخصصTIR',
    cancleGz: 'إلغاء المتابعة',
    cancleText: 'هل ترغب في إلغاء متابعة المستخدم الحالي؟',
    helpCenterTip: 'الوظيفة لم تفتح بعد'
  },
  // 血糖报告
  glucoseReport: {
    statics: 'إحصائيات',
    sixHour: 'TIR لمدة 6 ساعات',
    avgGlucose: 'متوسط ​​الجلوكوز',
    maxGlucose: 'أقصى مستوى جلوكوز',
    minGlucose: 'أدنى مستوى جلوكوز',
    cv: 'تقلب الجلوكوز',
    high: 'عدد الحالات المرتفعة',
    low: 'عدد الحالات المنخفضة',
    normal: 'عدد الحالات الطبيعية',
    tir: 'TIR',
    estimatedA1c: 'A1c المقدر',
    min: 'الحد الأدنى',
    avg: 'المتوسط',
    max: 'الحد الأقصى',
    maxVariation: 'أقصى تباين'
  },
  // 血糖档案
  glucoseProfile: {
    avg: 'المتوسط',
    sd: 'SD',
    cv: 'تقلب الجلوكوز'
  },
  // 事件列表
  eventList: {
    all: 'الكل',
    bg: 'سكر الدم',
    meal: 'الوجبة',
    sport: 'رياضة',
    insulin: 'الأنسولين',
    alert: 'تنبيه',
    eventType: 'نوع الحدث',
    description: 'الوصف',
    note: 'ملاحظة',
    highAlert: 'تنبيه مرتفع',
    calibration: 'المعايرة',
    meds: 'الأدوية',
    time: 'وقت',
    detail: 'تفاصيل',
    weigt: 'الوزن'
  },
  // 关注列表
  followerList: {
    title: 'مراقبة المستخدمين',
    tabTitle: 'إدارة المتابعين',
    refreshText:
      'تحديث تلقائي (يتم تحديث قائمة المستخدمين تلقائيًا كل 30 ثانية)',
    addText: 'إضافة',
    dataText: 'البيانات التي تم الحصول عليها',
    timeText: 'منذ دقائق',
    hourText: 'ساعات',
    agoText: 'قبل',
    tableEmail: 'أدخل رقم الحساب',
    searchPlacehold: 'يرجى إدخال رقم الحساب للبحث',
    pending: 'قيد الانتظار',
    approved: 'تمت الموافقة',
    rejected: 'مرفوض',
    addFollower: 'إضافة متابع',
    editFollower: 'تعديل المتابع',
    tableName: 'الاسم',
    tableAddTime: 'إضافة وقت',
    tableStatus: 'الحالة',
    tableApproved: 'تمت الموافقة',
    tableReject: 'رفض',
    tableStartSharing: 'بدء المشاركة',
    tableStopSharing: 'إيقاف المشاركة',
    op: 'تشغيل',
    sharing: 'مشاركة',
    notSharing: 'عدم مشاركة',
    tableRemove: 'إزالة',
    note: 'ملاحظة',
    message: 'رسالة',
    ruleMsgEmailEmpty: 'يرجى إدخال البريد الإلكتروني للبحث',
    ruleMsgNote: 'يرجى إدخال الملاحظة',
    ruleMsgMessage: 'يرجى ترك رسالة',
    ruleMsgEmailCorrect: 'يرجى إدخال بريد إلكتروني صحيح',
    formAcknowledge: 'أقر بأن إضافة متابع ستسمح لهذا المستخدم برؤية بياناتي',
    sendFollowRequest: 'إرسال طلب متابعة',
    setNote: 'تعيين ملاحظة',
    tipsAcknowledge:
      'يرجى تحديد المربع، أنت تقر بأن إضافة متابع ستسمح لهذا المستخدم برؤية بياناتي',
    stopSharing: 'إيقاف المشاركة',
    startSharing: 'بدء المشاركة',
    removeUser: 'إزالة المستخدم',
    confirmStopSharing:
      'هل أنت متأكد من إيقاف مشاركة الجلوكوز مع هذا المستخدم؟',
    confirmStartSharing: 'هل أنت متأكد من بدء مشاركة الجلوكوز مع هذا المستخدم؟',
    confirmRemove: 'هل أنت متأكد من إزالة هذا المستخدم من القائمة؟',
    approvedFollower: 'متابع معتمد',
    rejectFollower: 'رفض المتابع',
    confirmApproved: 'هل أنت متأكد من الموافقة على طلب المتابعة هذا؟',
    confirmReject: 'هل أنت متأكد من رفض طلب المتابعة هذا؟',
    addTime: 'إضافة وقت',
    check: 'تحقق',
    remove: 'إزالة',
    removeUserTitle: 'هل أنت متأكد من إزالة هذا المستخدم من القائمة؟'
  },
  // 设置
  settings: {
    title: 'إعدادات مستوى الجلوكوز',
    unitSet: 'إعداد الوحدة',
    targetSet: '\u202Aإعداد TIR المخصص\u202C',
    alertSet: 'إعداد التنبيه',
    highAlert: 'تنبيه مرتفع',
    lowAlert: 'تنبيه منخفض',
    urgentLow: 'منخفض جدا',
    urgentHigh: 'عالي جدا',
    target: 'الهدف'
  },
  // pdf
  pdf: {
    dailyStatistics: 'إحصائيات يومية',
    title: 'تقرير AGP: مراقبة الجلوكوز المستمرة',
    page: 'الصفحة',
    generated: 'تم الإنشاء',
    lage: 'اقصى سعة لتقلب نسبة السكر بالدم',
    mage: 'متوسط سعة تقلب السكر بالدم ',

    modd: 'متوسط الفروق اليومية',
    range: 'الوقت في النطاق',
    timeInRange: 'الوقت في النطاق (TIR)',
    agpTitle: '(AGP) ملف تعريف الجلوكوز المتنقل',
    agpSubTitle:
      'هو ملخص لقيم الجلوكوز لفترة التقرير، مع عرض الوسيط (50٪) والنسب المئوية الأخرى كما لو حدثت في يوم واحد AGP',
    dailyTitle: 'ملف تعريف الجلوكوز اليومي',
    dailySubTitle:
      '\u202Bيمثل كل ملف يومي فترة من منتصف الليل إلى منتصف الليل.\u202C',
    device: 'الجهاز',
    tDevice: 'الجهاز الطرفي',
    print: 'طباعة',
    model: 'الطراز',
    deviceSn: 'الرقم التسلسلي للجهاز',
    effectiveData: 'البيانات الفعالة',
    days: 'الأيام',
    appVer: 'إصدار التطبيق',
    smartPhoneModel: 'طراز الهاتف الذكي',
    osVersion: 'إصدار نظام التشغيل',
    appSetting: 'إعداد التطبيق',
    GoalsforType1andType2Diabetes: 'أهداف لمرضى السكري من النوع الأول والثاني',
    Each1timeinrange15minutes: 'كل 1% من الوقت في النطاق = 15 دقيقة تقريبًا',
    note: 'ملاحظة: وحدة % تنطبق على معيار DCCT، بينما وحدة mmol/mol تنطبق على معيار IFCC.',
    DOB: 'تاريخ الميلاد',
    SN: 'الرقم التسلسلي'
  },
  // 字段
  field: {
    timeCgmActive: '(CGM)وقت تفعيل جهاز مراقبة الجلوكوز المستمر',
    gmi: 'GMI',
    gri: 'GRI',
    eHbA1c: 'eHbA1c',
    avgPerDay: 'متوسط المعايرة يوميًا',
    glucoseAbility: 'تباين الجلوكوز',
    lage: 'اقصى سعة لتقلب نسبة السكر بالدم',
    mage: 'متوسط سعة تقلب السكر بالدم ',
    tar: 'TAR',
    tbr: 'TBR',
    calibrations: 'مرات المعايرة'
  },
  agp: {
    agpTitle: '(AGP)ملف الجلوكوز المتنقل ',
    centerLine: 'الوسيط',
    areaLine: 'النطاق',
    target: 'النطاق المستهدف'
  },
  basic: {
    customTir: ' المخصص TIR',
    bloodTip: 'إعدادات تذكير الجلوكوز',
    bloodUnit: 'وحدة الجلوكوز',
    highTip: 'تنبيه مرتفع',
    lowTip: 'تنبيه منخفض',
    unitText: 'يتم الضبط تلقائيًا بناءً على البلد والمنطقة',
    selectTip: 'انقر على الرمز لتحديد أو إلغاء تحديد التاريخ المقابل',
    selectAll: 'تحديد الكل'
  },
  report: {
    threeMonth: 'آخر 3 أشهر',
    sixMonth: 'آخر 6 أشهر',
    yearText: 'العام الماضي',
    showAll: 'إظهار الكل',
    all: 'الكل',
    selectDate: 'تحديد نطاق التاريخ',
    to: 'إلى',
    startDt: 'تاريخ البدء',
    endDt: 'تاريخ الانتهاء',
    betaTest: 'اختبار تجريبي',
    bloodData: 'بيانات الجلوكوز',
    userCount: 'المستخدم الحسابات'
  },
  petDetail: {
    variety: 'السلالة',
    type: 'نوع الأنسولين',
    freq: 'تكرار الأنسولين',
    lente: 'Lente',
    insulin: 'إنسولين جلارجين',
    pzi: 'PZI',
    nph: 'NPH',
    detemir: 'ديتيمير'
  },
  pdfReport: {
    title: 'AGP تقرير',
    snNumber: 'الرقم التسلسلي',
    page: 'الصفحة',
    createTime: 'تم الإنشاء',
    petInfo: 'معلومات الحيوان الأليف',
    petName: 'اسم الحيوان الأليف',
    birthday: 'تاريخ الميلاد',
    freq: 'تكرار الأنسولين',
    petType: 'نوع الحيوان الأليف',
    age: 'العمر',
    registerType: 'نوع الحقنة',
    basicBloodData: 'مقاييس الجلوكوز',
    dbText: '(TIR)الوقت في النطاق ',
    target: 'الأهداف لمرض السكري من النوع 1 والنوع 2',
    recordTime: 'وقت التسجيل',
    tag: 'علامة',
    event: 'الحدث',
    eventDetail: 'تفاصيل الحدث',
    mulityText: 'مخطط اتجاهات الجلوكوز لعدة أيام',
    mulitySubText:
      'تمثل ملفات تعريف الجلوكوز لعدة أيام الفترة الزمنية لدورة الجهاز',
    avageBlood: 'متوسط الجلوكوز',
    bloodText: 'MODD',
    highTip: 'تنبيه مرتفع',
    lowTip: 'تنبيه منخفض',
    cat: 'قط',
    dog: 'كلب',
    country: 'بلد',
    insulinDose: 'جرعة الأنسولين',
    weightUnit: 'كجم'
  },
  eventDetail: {
    Empty: 'فارغ',
    After_Breakfast: 'بعد الإفطار',
    Before_Lunch: 'قبل الغداء',
    Breakfast: 'الإفطار',
    Lunch: 'الغداء',
    Dinner: 'عشاء',
    Before_Sleep: 'قبل النوم',
    Extra: 'إضافي',
    Short_acting: 'قصير المفعول',
    Pre_mixed: 'مُخَلَّط مسبقًا',
    Long_acting: 'طويل المفعول',
    Middle_acting: 'متوسط ​​المفعول',
    hour: 'س',
    minutes: 'د'
  }
};
export default ar;
